export class UiToolbar
{
	constructor(options = {name: "MainUiGrid"}) {
		this.name = options.name;
        this.defaultToolbar = null;

        BX.ready(this.init.bind(this))
	}

    init() {
        if (BX &&
            BX.UI &&
            BX.UI.ToolbarManager &&
            BX.UI.ToolbarManager.toolbars &&
            BX.UI.ToolbarManager.toolbars["default-toolbar"]
        ) {
            this.defaultToolbar = BX.UI.ToolbarManager.toolbars["default-toolbar"];

            this.learnedLessonsList();
            this.checklistsAndPrescriptionsList();
            this.cumulativeBnbList();
        }

        return;
    }

    // list: Накопительный реестр необходимых улучшений процессов, Бурового оборудования, Технологий (БнБ)
    cumulativeBnbList() {
        let iListId = BX.message("LIST_ID_CUMULATIVE_REGISTER_DRILL_EQUIP_TECH_BNB");
        let sListPath = `/bizproc/processes/${iListId}/view/0/`;
        if (location.pathname.indexOf(sListPath) == -1) {
            return;
        }

        this.addResetListSettingsActionMenuItem(iListId);

        return;
    }

    // list: Извлеченные уроки
    learnedLessonsList() {
        let iListId = BX.message("LIST_ID_LEARNED_LESSONS");
        let sListPath = `/bizproc/processes/${iListId}/view/0/`;
        if (location.pathname.indexOf(sListPath) == -1) {
            return;
        }

        this.addResetListSettingsActionMenuItem(iListId);

        return;
    }

    // list: Реестр улучшений по чек листам и предписаниям
    checklistsAndPrescriptionsList() {
        let iListId = BX.message("LIST_ID_REGISTER_CHECKLIST_PRESCRIPTION");
        let sListPath = `/bizproc/processes/${iListId}/view/0/`;
        if (location.pathname.indexOf(sListPath) == -1) {
            return;
        }

        this.addResetListSettingsActionMenuItem(iListId);

        return;
    }

    addResetListSettingsActionMenuItem(iListId) {
        this.addActionMenuItem(
            "Сбросить настройки списка",
            this.resetListSettings.bind(this, iListId)
        );
    }

    resetListSettings(iListId) {
        let sJson = JSON.stringify({
            "method": "resetListListSettings",
            "data": {"iListId": iListId}
        });

        BX.ajax({
            url: "/api/v1/lists/",
            method: "POST",
            processData: true,
            dataType: "json",
            data: sJson,
            onsuccess: function (oData) {
                location.reload();
            }
        });
    }

    addActionMenuItem(sTitle, fCallback) {
        let obButtons = this.defaultToolbar.getButtons();
        for (let [key, obButton] of Object.entries(obButtons)) {
            if (obButton.baseClass == "ui-btn") { // grey wheel button
                obButton.options.menu.items.push({"text": sTitle, "onclick": fCallback});
                obButton.setMenu(obButton.options.menu);
                break;
            }
        }
    }
}
